import React from 'react';

import { Box, Text } from 'grommet';
import { Alert, CircleQuestion, User, StatusCritical } from "grommet-icons"

export const Warn = ({ warning, subWarning, minheight }) => {

    const color = 'ttwarning'

    return (
        <Box background="light-1"
            height={{ min: minheight || null }}
            elevation="xsmall"
            alignSelf="start" alignContent="start" pad="small" direction="row"
            round="xsmall" align="center" gap="small" border={{ size: "small", side: "all", color: color }}>
            <Alert size="medium" color="ttdown" />
            <Box gap="xsmall">
                <Text size="16px" color={color} weight="bold">{warning}</Text>
                {subWarning && subWarning.length > 0 &&
                    <Text size="13px" weight='normal' color='dark-3'>{subWarning}</Text>
                }
            </Box>
        </Box>
    )
}

export const Err = ({ warning, subWarning }) => {

    const color = 'ttdown'

    return (
        <Box background="light-1"
            height="80px"
            elevation="xsmall"
            alignSelf="start" alignContent="start" pad="small" direction="row" round="xsmall" align="start" gap="small" border={{ size: "small", side: "all", color: color }}>
            <StatusCritical size="medium" color="ttdown" />
            <Box gap="xsmall">
                <Text size="16px" color={color} weight="bold">{warning}</Text>
                {subWarning && subWarning.length > 0 &&
                    <Text size="13px" weight='bold' color='ttdown'>{subWarning}</Text>
                }
            </Box>
        </Box>
    )
}


export const WarnEnvNotSelected = () => (
    <Box fill background="light-1" pad="small">
        <Warn warning="Environment not selected" subWarning="Select environment from top application bar." />
    </Box>
)

export const LiteModeOnly = () => (
    <Box fill background="light-1" pad="small">
        <Warn warning="Lite Mode Only" subWarning="Please view this via your local machine through https://control-lite.trade.tt" />
    </Box>
)


export const XWarnEnvNotSelected = () => {
    return (
        <Box background="light-1"
            elevation="xsmall"
            alignSelf="start" alignContent="start" pad="small" direction="row" round="xsmall" align="start" gap="small" border={{ size: "small", side: "all", color: "ttwarning" }}>
            <Alert size="medium" color="ttdown" />
            <Box gap="xsmall">
                <Text size="16px" color="ttwarning" weight="bold">Environments not setup in profile</Text>
                <Box direction="row" gap="xsmall">
                    <Text size="small" color="dark-3">Click on</Text>
                    <User color="brand" size="18px" />
                    <Text size="small" color="dark-3">to setup profile.</Text>
                </Box>
                <Box direction="row" gap="xsmall">
                    <Text size="small" color="dark-3">To begin a tour of control, click on</Text>
                    <CircleQuestion color="brand" size="20px" />
                </Box>
            </Box>
        </Box>
    )
}

export default Warn
